import colors from "constants/colors";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";

const options_UnscrambleSplitCharacter = [
  { label: 'Cấp độ kí tự', value: '', optionType: 'UNSCRAMBLE_WORDS' },
  { label: 'Cấp độ từ', value: ' ', optionType: 'UNSCRAMBLE_SENTENCE' },
  { label: 'Tuỳ chỉnh theo dấu | ', value: '|', optionType: 'UNSCRAMBLE_NORMAL' },
];

const options_TickTFCharacter = [
    { label: 'Yes/No', value: 'Yes/No', icon1: <strong style={{ color: colors.theme.success }}>Yes</strong>, icon2: <strong style={{ color: colors.theme.danger }}>No</strong> , optionType: 'TICKTF_YESNO'},
    { label: 'T/F', value: 'T/F', icon1: <strong style={{ color: colors.theme.success }}>T</strong>, icon2: <strong style={{ color: colors.theme.danger }}>F</strong> , optionType: 'TICKTF_TF'},
    { label: 'True/False', value: 'True/False', icon1: <strong style={{ color: colors.theme.success }}>True</strong>, icon2: <strong style={{ color: colors.theme.danger }}>False</strong> , optionType: 'TICKTF_TRUEFALSE'},
    { label: 'Tick/Cross', value: 'Tick/Cross', icon1: <AiOutlineCheck size={27} color={colors.theme.success} />, icon2: <AiOutlineClose size={27} color={colors.theme.danger} /> , optionType: 'TICKTF_TICKCROSS'},
  ];

export { options_UnscrambleSplitCharacter , options_TickTFCharacter};
